module.exports = __webpack_public_path__ + "media/images/application/template/select-arrow-down-white-c142ee4807ded8d7a3c85414897ae774.svg";